module.exports = __webpack_public_path__ + "img/PBS_0424-Edit-2.837ffe9b.jpg";